import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './PlantSelectorDropdown.module.css';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { Select } from '../../atomicComponents';
import { HEX_COLORS, JLR_PLANT } from '../../constants';

const PlantSelectorDropdown = ({ isDarkStyle }) => {
  const [plant, setPlant] = usePlantAndLinesStore().plantState;
  const [plantOptions] = usePlantAndLinesStore().plantOptions;

  const handlePlantChange = valueObject => {
    setPlant(valueObject);
  };

  return (
    <Select
      value={plant}
      selectName="plants"
      borderStyle={
        JLR_PLANT === plant.label
          ? `solid 1px ${HEX_COLORS.GRAY}`
          : `solid 1px ${HEX_COLORS.BLUE}`
      }
      fontColor={JLR_PLANT === plant.label ? '#707070' : '#0275A7'}
      selectClassName={clsx(
        styles.dropdown,
        styles.select,
        isDarkStyle && styles.dropdownDark,
      )}
      onChange={handlePlantChange}
      options={plantOptions}
    />
  );
};

PlantSelectorDropdown.propTypes = {
  isDarkStyle: PropTypes.bool,
  plant: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  plantOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  setPlant: PropTypes.func.isRequired,
};

export default PlantSelectorDropdown;
